import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
};

export const SkeletonLoader = ({ className }: Props) => (
  <div
    data-testid="skeleton-loader"
    className={twMerge(
      'h-4 w-full animate-pulse rounded-radius-sys-radius-4 bg-color-ref-ui-surface-container',
      className,
    )}
  />
);
